<template>
  <div class="TableConfigDialogs">
    <el-dialog
      title="表格配置"
      width="50%"
      :visible.sync="visible"
      @close="$emit('update:show', false)"
      :show="show"
    >
      <div class="content_box">
        <el-table
          ref="table"
          :data="data"
          border
          style="width: 100%"
          height="300"
          :header-cell-style="{background:'#eef1f6',color:'#606266'}"
          :highlight-current-row="true"
          :row-class-name="tableRowClassName"
          @row-click="clickRow"
        >
          <el-table-column type="index" width="50" align="center"></el-table-column>
          <el-table-column prop="Name" align="center" label="列名"></el-table-column>
          <el-table-column align="center" label="显示名">
            <template slot-scope="scope">
              <el-input v-model="scope.row.Rename" size="mini" class="input_sty"></el-input>
            </template>
          </el-table-column>
          <!-- <el-table-column align="center" width="120" label="列宽">
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.width" size="mini" class="input_sty"></el-input>
                        </template>
          </el-table-column>-->
          <el-table-column prop="date" align="center" label="是否显示" width="80">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.Show" :disabled="scope.row.Must"></el-checkbox>
            </template>
          </el-table-column>

          <!-- <el-table-column align="center" label="是否打印" width="80">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.Print"></el-checkbox>
            </template>
          </el-table-column> -->
        </el-table>
      </div>
      <div class="content_footer_box">
        <el-button
          type="success"
          size="mini"
          style="display:block"
          :disabled="canUp"
          @click="moveUp"
        >上移</el-button>
        <el-button
          type="success"
          size="mini"
          style="display:block"
          :disabled="candown"
          @click="moveDown"
        >下移</el-button>
        <el-button type="primary" size="mini" style="display:block" @click="restoreDefault">恢复默认</el-button>
        <el-button type="success" size="mini" style="display:block" @click="saveInfor">保存</el-button>
        <el-button size="mini" style="display:block" @click="$emit('update:show', false)">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>  

<script>
import tool from "@/utils/tool"; //本地缓存存取
export default {
  // 注册组件
  components: {},
  data() {
    return {
      visible: this.show, //是否显示弹出框
      // tableData:tableData,//table表格数据
      data: this.tableData, //table表格数据
      canUp: true, //是否可上移
      candown: true, //是否可下移
      isactive: 0, //切换个人配置与全局配置
      rowData: {}, //把点击某行的数据存储
      $index: Number //每行的索引
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    tableData: [Object, Array]
  },
  methods: {
    // 把table每行索引装进去
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex;
    },
    // 点击某一行时获取index判断是否能够上下移动
    clickRow(row) {
      this.rowData = row;
      this.canUp = false;
      this.candown = false;
    },
    // 交换数组元素
    swapItems(arr, index1, index2) {
      let tenmplate = arr[index1];
      arr[index1] = arr.splice(index2, 1, arr[index1])[0];
      arr[index2] = tenmplate;
      return arr;
    },
    // 上移
    moveUp() {
      for (var i = 0; i < this.tableData.length; i++) {
        if (this.tableData[i].Name === this.rowData.Name) {
          this.$index = i;
          break;
        }
      }
      if (this.$index !== 1) {
        if (this.$refs.table.bodyWrapper.scrollTop >= 0) {
          this.$refs.table.bodyWrapper.scrollTop -= 49;
        }
        if (this.$index == 0) {
          this.$message({
            message: "该行不能再上移了",
            type: "warning"
          });
          return;
        }
        this.tableData = this.swapItems(
          this.tableData,
          this.$index,
          this.$index - 1
        );
      } else {
        this.$message({
          message: "该行不能再上移了",
          type: "warning"
        });
        return;
      }
    },
    // 下移
    moveDown() {
      for (var i = 0; i < this.tableData.length; i++) {
        if (this.tableData[i].Name === this.rowData.Name) {
          this.$index = i;
          break;
        }
      }
      if (this.$refs.table.bodyWrapper.scrollTop !== 0 || this.$index !== 0) {
        if (
          this.$refs.table.bodyWrapper.scrollTop <=
          this.tableData.length * 49
        ) {
          this.$refs.table.bodyWrapper.scrollTop += 49;
        }
        if (this.$index == this.tableData.length - 1) {
          this.$message({
            message: "该行不能再下移了",
            type: "warning"
          });
          return;
        }
        this.tableData = this.swapItems(
          this.tableData,
          this.$index,
          this.$index + 1
        );
      } else {
        this.$message({
          message: "该行不能再下移了",
          type: "warning"
        });
        return;
      }
    },
    // 保存
    saveInfor() {
      // 重新为数组Reno赋值新的索引
      let configData = this.tableData.map((item, index) => {
        item.ReNo = index;
        return item;
      });
      let params = {
        user_id: tool.getLocal("userid"),
        session_id: tool.getLocal("sessionid"),
        Model: this.$attrs.pargam.Model, //从祖父页面传递过来的表示是什么页面，saleorder等
        data: configData
      };
      this.request
        .post("/index/Settings/modify_function_fields", {
          jparams: JSON.stringify(params)
        })
        .then(res => {
          // 接收后端发送回来的数据
          this.$emit("update:show", false);
          this.$emit("saveTableConfig");
        })
        .catch(err => {
          console.log(err);
        });
    },
    //恢复默认
    restoreDefault() {
      let params = {
        user_id: tool.getLocal("userid"),
        session_id: tool.getLocal("sessionid"),
        Model: this.$attrs.pargam.Model,
        type: 1
      };
      this.request
        .post("/index/Settings/recover_function_fields", {
          jparams: JSON.stringify(params)
        })
        .then(res => {
          // 接收后端发送回来的数据
          if (res.status == 0) {
            // 给页面配置系数据赋值
            this.$emit("restoreDefault", res.data.body);
            this.$emit("defaultTableConfig");
            this.$emit("update:show", false);
            this.$message({
              message: "恢复默认成功",
              type: "warning"
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 超出8个打印列时弹出提示框
    PrintAlert() {
      let printLen = 0;
      this.tableData.map(item => {
        if (item.Print) {
          printLen++;
        }
      });
      if (printLen > 8) {
        this.$message({
          message: "打印最多显示8列，多余列可能显示不出来",
          type: "warning"
        });
      }
    }
  },
  watch: {
    show() {
      this.visible = this.show;
    },
    // 监听tableData改变
    tableData: {
      handler(newValue, oldValue) {
        this.data = newValue;
        // this.PrintAlert()
      },
      deep: true
    }
  },
  // 创建生命周期钩子函数
  mounted() {}
};
</script>
<style lang="less" scoped>
.TableConfigDialogs {
 /deep/  .el-dialog__header {
    background: rebeccapurple;
    // background: #4990d7;
    padding: 10px 10px 0 !important;
    .el-dialog__title {
      color: #fff;
      font-size: 14px;
    }
    .el-dialog__headerbtn {
      top: 10px;
      right: 10px;
      .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
      }
    }
  }
  .el-dialog__body {
    padding: 10px 20px;
  }
  .content_box {
  }
  .content_footer_box {
    display: -webkit-box !important;
    display: box !important;
    position: relative;
    -webkit-box-align: center;
    box-align: center;
    -webkit-box-pack: end;
    box-pack: end;
    margin: 10px auto 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Dialog/HeaderElastic/HeaderElastic.vue